import React, { useEffect } from 'react';
import { ServiceEmailNotification } from '../../models/ServiceEmailNotificationModel';
import './styles/EmailNotificationToast.css';

interface Props {
  notification: ServiceEmailNotification;
  onOpen: () => void;
  onDismiss: () => void;
}

const TOAST_DURATION_MS = 12_000;

const EmailNotificationToast: React.FC<Props> = ({
  notification,
  onOpen,
  onDismiss,
}) => {
  useEffect(() => {
    const timer = window.setTimeout(onDismiss, TOAST_DURATION_MS);
    return () => window.clearTimeout(timer);
  }, [notification.id, onDismiss]);

  const route = [notification.payload?.origin_name, notification.payload?.destination_name]
    .filter(Boolean)
    .join(' → ');

  return (
    <aside className="email-notification-toast" role="status" aria-live="polite">
      <div className="email-notification-toast__icon" aria-hidden="true">✉</div>
      <div className="email-notification-toast__content">
        <p className="email-notification-toast__eyebrow">
          {notification.type === 'UPCOMING_SERVICE' ? 'Sin conductor' : 'Solicitudes'}
        </p>
        <strong className="email-notification-toast__title">{notification.title}</strong>
        <p className="email-notification-toast__message">{notification.message}</p>
        {route && <p className="email-notification-toast__route">{route}</p>}
        <button
          className="email-notification-toast__open"
          type="button"
          onClick={onOpen}
        >
          {notification.type === 'UPCOMING_SERVICE' ? 'Ver servicio' : 'Ver correo'}
        </button>
      </div>
      <button
        className="email-notification-toast__close"
        type="button"
        onClick={onDismiss}
        aria-label="Cerrar notificación"
      >
        ×
      </button>
    </aside>
  );
};

export default EmailNotificationToast;
